/**
 * sessionStorage/localStorage can throw in restricted contexts —
 * in-app browsers (WhatsApp, Instagram, Facebook, Messenger link previews),
 * iOS Safari private mode, or webviews with storage disabled. A thrown
 * error here during a state initializer or callback can silently break
 * the whole render (e.g. a state update never happens), which is exactly
 * the "site goes blank after the intro" bug on mobile. Always go through
 * these helpers instead of calling storage APIs directly.
 */

export function safeSessionGet(key: string): string | null {
  try {
    return window.sessionStorage.getItem(key)
  } catch {
    return null
  }
}

export function safeSessionSet(key: string, value: string): void {
  try {
    window.sessionStorage.setItem(key, value)
  } catch {
    // Ignore — storage unavailable, feature just won't persist this session.
  }
}

export function safeLocalGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function safeLocalSet(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // Ignore — storage unavailable.
  }
}
